import * as React from 'react';
import { render } from 'react-dom';
import '../../design/agenda/index.scss';
import { AgendaPage } from './pages/AgendaPage';
function readPreloadedEvents() {
    var node = document.querySelector('#agenda-events');
    if (!node || !node.textContent) {
        return [];
    }
    try {
        var events = JSON.parse(node.textContent);
        return Array.isArray(events) ? events : [];
    }
    catch (error) {
        return [];
    }
}
document.addEventListener('DOMContentLoaded', function () {
    var _a, _b, _c, _d, _e;
    var root = document.querySelector('#root');
    if (!root) {
        return;
    }
    render(React.createElement(AgendaPage, { agendaSlug: (_a = root.getAttribute('data-agenda-slug')) !== null && _a !== void 0 ? _a : '', season: (_b = root.getAttribute('data-season')) !== null && _b !== void 0 ? _b : '', type: (_c = root.getAttribute('data-type')) !== null && _c !== void 0 ? _c : '', subtitle: (_d = root.getAttribute('data-subtitle')) !== null && _d !== void 0 ? _d : '', userEmail: (_e = root.getAttribute('data-user-email')) !== null && _e !== void 0 ? _e : '', initialEvents: readPreloadedEvents() }), root);
});
